import { createTheme } from '@material-ui/core';
import * as Colors from './colors';
import * as Type from './text';

/**
 * Set defaults and overrides for Material UI Components
 */
export const materialTheme = createTheme({
  palette: {
    primary: {
      main: Colors.blue[700]
    },
    secondary: {
      main: Colors.blue[600]
    },
    background: {
      default: '#fff'
    },
    success: {
      main: Colors.status.success.dark // priority 1
    },
    info: {
      main: Colors.status.info.dark // priority 1
    },
    error: {
      main: Colors.status.error.dark // priority 1
    },
    warning: {
      main: Colors.status.warning.dark // priority 1
    }
  },
  typography: {
    fontFamily: Type.fontFamilies.body,
    h1: {
      fontFamily: Type.fontFamilies.heading,
      fontSize: Type.typeScale.h1,
      fontWeight: 600
    },
    h2: {
      fontFamily: Type.fontFamilies.heading,
      fontSize: Type.typeScale.h2,
      fontWeight: 300,
      color: Colors.blue[600]
    },
    h3: {
      fontFamily: Type.fontFamilies.heading,
      fontSize: Type.typeScale.h3,
      fontWeight: 600,
      textTransform: 'uppercase'
    },
    h4: {
      fontFamily: Type.fontFamilies.heading,
      fontSize: Type.typeScale.h4,
      fontWeight: 300,
      textTransform: 'uppercase'
    },
    h5: {
      fontFamily: Type.fontFamilies.heading,
      fontSize: Type.typeScale.h5,
      fontWeight: 600
    },
    h6: {
      fontFamily: Type.fontFamilies.heading,
      fontSize: Type.typeScale.h6,
      fontWeight: 300
    }
  },
  overrides: {
    MuiMenuItem: {
      root: {
        '&$selected': {
          backgroundColor: '#eaf3f8 !important',
          color: 'black'
        }
      }
    },
    MuiFormControlLabel: {
      label: {
        fontFamily: Type.fontFamilies.body,
        fontWeight: 300,
        fontSize: 14,
        letterSpacing: '0.3px',
        color: '#000000'
      }
    },
    MuiFormLabel: {
      root: {
        fontFamily: Type.fontFamilies.heading,
        fontWeight: 300,
        color: '#4f4f4f !important',
        fontSize: 14,
        backgroundColor: 'white',
        '&$focused': {
          color: '#4f4f4f !important'
        }
      }
    },
    MuiInputLabel: {
      root: {
        fontFamily: Type.fontFamilies.heading,
        fontWeight: 300,
        color: '#4f4f4f !important',
        fontSize: 14,
        backgroundColor: 'white'
      },
      outlined: {
        fontFamily: Type.fontFamilies.heading,
        fontWeight: 300,
        color: '#4f4f4f !important',
        fontSize: 14
      }
    }
  }
});
